import { useDroppable } from "@dnd-kit/core"

type DroppableAreaProps = {
  id: string
  contentDefault?: JSX.Element | null
  contentIsOver?: JSX.Element | null
  contentActive?: JSX.Element | null
  children?: JSX.Element | null
  className?: string | null
}

export const DroppableArea = ({
  id,
  contentDefault = null,
  contentIsOver = null,
  contentActive = null,
  children = null,
  className = null,
}: DroppableAreaProps) => {
  const { setNodeRef, active, isOver } = useDroppable({
    id,
  })

  let content: JSX.Element | null

  if (active) {
    content = contentActive
  } else if (isOver) {
    content = contentIsOver
  } else {
    content = contentDefault
  }

  return (
    <div
      id={id}
      ref={setNodeRef}
      className={`${
        active
          ? "border-2 border-dashed border-green-500 rounded-md " + className
          : className
      }`}>
      {children}
      {content && (
        <div className="rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] box-border w-full h-[98px] overflow-hidden flex flex-col py-3 px-3.5 z-[2] border-[1px] border-solid border-gray-300">
          {content}
        </div>
      )}
    </div>
  )
}
